<template>
  <div class="table">
    <table>
      <slot name="similar-th"></slot>
      <slot name="similar-td"></slot>
    </table>
  </div>
</template>

<script>
export default {
  name: "cwSimilarTable",
};
</script>

<style lang="less">
.table {
  width: 100%;
  // border: solid 1px;
  box-sizing: border-box;
  margin-top: 30px;
  table {
    width: 100%;
    // border: solid 1px red;
    box-sizing: border-box;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/cw-similar-Table.vue